import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";

export function FeaturesSection() {
  const features = [
    {
      title: "Instant Domain Search",
      description: "Our powerful search engine checks domain availability across hundreds of TLDs in real-time.",
      icon: "https://storage.googleapis.com/fenado-ai-farm-public/generated/375662a1-0dcd-45b6-ae18-2b6c52b3fffe.webp",
      delay: 0.1
    },
    {
      title: "Transparent Pricing",
      description: "No hidden fees. Get affordable and straightforward pricing on all our domain names.",
      icon: "https://storage.googleapis.com/fenado-ai-farm-public/generated/c18097fe-b083-42c1-9e59-5ee14d7f509f.webp",
      delay: 0.2
    },
    {
      title: "Simple Management",
      description: "An intuitive dashboard to manage all your domains, DNS settings, and renewals in one place.",
      icon: "https://storage.googleapis.com/fenado-ai-farm-public/generated/e2ba0c33-b2b7-4767-990f-d76762f434fa.webp",
      delay: 0.3
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Why Choose DomainDash
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We make domain registration simple, transparent, and hassle-free.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: feature.delay }}
              viewport={{ once: true }}
            >
              <Card className="h-full bg-card hover:shadow-md transition-all duration-300 border border-border">
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <div className="mb-5 p-3 rounded-full bg-primary/10">
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      className="w-12 h-12"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}